<template>
    <div class="wl-site-manager">
        <div class="u-school-manager-head">
            <router-link :to="{name:'certifyStadard'}" class="sp-link-a">申请标准</router-link>
            <router-link :to="{name:'siteAuthentication'}" class="sp-link-a">站点申请</router-link>
            <router-link :to="{name:'siteManagement'}" class="sp-link-a">站点管理</router-link>
            <router-link :to="{name:'siteActivity'}" class="sp-link-a">站点活动</router-link>
            <!-- <router-link :to="{name:'authenticationNode'}" class="sp-link-a">认证节点</router-link> -->
        </div>
        <div class="wl-index-content-wrapper">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
import SiteIndexManage from "page/xSchool/manager/SiteIndexManage.vue";
export default {
  data(){
      return {
          
      }
  },
  components:{
      SiteIndexManage
  }
}
</script>

<style lang="scss">
.wl-site-manager{
    .u-school-manager-head{
        text-align: left;
        margin-bottom: 20px;
        .sp-link-a{
            width: 140px;
            display: inline-block;
            color: #303133;
            text-align: left;
            text-align: center;
            height: 60px;
            line-height: 60px;
            font-size: 16px;
        }
        .linkActive{
            border-bottom: 2px solid #409EFF;
            color: #409EFF;
        } 
    }
    .wl-index-content-wrapper{
        margin: 80px 0 0 30px;
        padding: 20px;
        background: #fff;
    }
}
</style>

